import Vue from "vue";
Vue.mixin({
    mounted()
    {
        if (this.$root !== this)
        {
            return;
        }
        const wrapperMain = document.querySelector(".wrapper-main");

        this.$root.$on("aside-toggled", (val) =>
        {
            document.body.classList.toggle("aside-open", val);
        });
        this.$root.$on("toggle-fixed-body", (val, setInert = false) =>
        {
            document.body.classList.toggle("fixed", val);
            if (wrapperMain && setInert)
            {
                // BFSG
                wrapperMain.inert = document.body.classList.contains("fixed");
            }

            if (!setInert)
            {
                wrapperMain.inert = false;
            }
        });
    }
});
